import * as swcHelpers from '@swc/helpers';
import { EXISTING_CUSTOMER, EMAIL_PRESCRIPTION, PRESCRIPTION_FILE, NEW_PRESCRIPTION, NEW_PRESCRIPTION_AND_UPLOAD } from '../state/constants.js';

const convertCmsRxEntries = (entryTypes)=>{
    if (!entryTypes) return;
    const ConversionMap = {
        'existing-customer': EXISTING_CUSTOMER,
        email: EMAIL_PRESCRIPTION,
        'file-upload': PRESCRIPTION_FILE,
        'form-entry': NEW_PRESCRIPTION,
        'form-upload': NEW_PRESCRIPTION_AND_UPLOAD,
        'book-appointment': 'book-appointment'
    };
    return entryTypes.map((item)=>swcHelpers.objectSpread({}, item, {
            key: ConversionMap[item.key]
        })
    );
};

export { convertCmsRxEntries };
//# sourceMappingURL=convert-cms-rx-entries.js.map
